import React, { forwardRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { FaHome, FaLeaf, FaBuilding } from "react-icons/fa";
import { DayPicker } from "react-day-picker";
import { format } from "date-fns";
import "react-day-picker/dist/style.css";
import "./Booking.css";

const BookingForm = forwardRef((_, ref) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    serviceDescription: "",
    preferredDate: undefined,
    preferredTime: "",
    spaceType: "Home",
  });

  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const serviceID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
    const templateID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;

    const templateParams = {
      name: formData.name,
      email: formData.email,
      phone: formData.phone || "Not provided",
      serviceDescription: formData.serviceDescription,
      preferredDate: formData.preferredDate
        ? format(formData.preferredDate, "yyyy-MM-dd")
        : "Not specified",
      preferredTime: formData.preferredTime || "Not specified",
      spaceType: formData.spaceType,
    };

    emailjs
      .send(serviceID, templateID, templateParams, {
        publicKey: process.env.REACT_APP_EMAILJS_PUBLIC_KEY,
      })
      .then(
        () => setIsSubmitted(true),
        (error) => {
          alert("An error occurred, please try again.");
          console.error("EmailJS Error:", error);
        }
      );
  };

  return (
    <div ref={ref} className="booking-wrapper">
      <div className="booking-card">
        {isSubmitted ? (
          <div className="confirmation-message">
            <h2>Thank you!</h2>
            <p>
              Your booking request has been sent successfully. We’ll be in touch
              soon.
            </p>
          </div>
        ) : (
          <>
            <h2 className="booking-title">Book a Spiritual Cleansing</h2>
            <form onSubmit={handleSubmit} className="booking-form">
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={formData.name}
                onChange={handleChange}
                required
                className="booking-input"
              />
              <input
                type="email"
                name="email"
                placeholder="Your Email"
                value={formData.email}
                onChange={handleChange}
                required
                className="booking-input"
              />
              <input
                type="tel"
                name="phone"
                placeholder="Your Phone Number (Optional)"
                value={formData.phone}
                onChange={handleChange}
                className="booking-input"
              />
              <textarea
                name="serviceDescription"
                placeholder="Describe the Services You Need"
                value={formData.serviceDescription}
                onChange={handleChange}
                required
                className="booking-textarea"
              />

              <div className="form-field">
                <label className="booking-label">Preferred Date</label>
                <input
                  type="date"
                  name="preferredDate"
                  value={formData.preferredDate}
                  onChange={handleChange}
                  className="booking-input"
                />
              </div>
              {/* Space Type */}
              <div style={{ textAlign: "left" }}>
                <label className="space-type-label">Type of Space</label>
                <div className="space-type-options">
                  {[
                    { label: "Home", icon: <FaHome /> },
                    { label: "Land", icon: <FaLeaf /> },
                    { label: "Business space", icon: <FaBuilding /> },
                  ].map((option) => (
                    <label
                      key={option.label}
                      className={`space-type-option${
                        formData.spaceType === option.label ? " selected" : ""
                      }`}
                    >
                      <input
                        type="radio"
                        name="spaceType"
                        value={option.label}
                        checked={formData.spaceType === option.label}
                        onChange={handleChange}
                        style={{ display: "none" }}
                      />
                      <span style={{ fontSize: "1.2rem" }}>{option.icon}</span>
                      <span>{option.label}</span>
                    </label>
                  ))}
                </div>
              </div>

              <button type="submit" className="booking-button">
                Send Booking Request
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
});

export default BookingForm;
